const SystemADASLDWS: { [key: string]: string } = {
  "0": "Off",
  "1": "On(50km/h)",
  "2": "On(60km/h)",
  "3": "On(70km/h)",
};

export default SystemADASLDWS;
